export default "__VITE_PUBLIC_ASSET__cc916dfe__"